module.exports = __webpack_public_path__ + "static/img/2.7c885f90.jpg";